const AuthApi = {
  get: (type) => {
    // const url = [window.domain, window.prefix, '/api'].join('');
    const url = 'http://api.dantemoscow.ru/api';
    const method = 'POST';
    const headers = {'Content-Type': 'application/json; charset=utf-8'};    
    const body = JSON.stringify({type});
    // console.log(body);
    return fetch(url, {method, body, headers, credentials: 'include'});
  },

  reg: (name, email, password) => {
    const url = [window.domain, window.prefix, '/auth/reg'].join('');
    const method = 'POST';
    const headers = {'Content-Type': 'application/json'};
    const body = JSON.stringify({name, email, password});

    return fetch(url, {method, body, headers, credentials: 'include'});
  },

  restore: (email) => {
    const url = [window.domain, window.prefix, '/auth/restore'].join('');
    const method = 'POST';
    const headers = {'Content-Type': 'application/json'};
    const body = JSON.stringify({email});

    return fetch(url, {method, body, headers, credentials: 'include'});
  },

  logout: () => {
    const url = [window.domain, window.prefix, '/auth/logout'].join('');
    const method = 'POST';
    const headers = {'Content-Type': 'application/json'};

    return fetch(url, {method, headers, credentials: 'include'});
  }
};

export default AuthApi;


// WEBPACK FOOTER //
// ./src/api/index.js